/* eslint-disable linebreak-style */
import styled from 'styled-components';

export const AbaContainerAcompanhamento = styled.div`
  background: linear-gradient(to bottom, transparent, rgba(221,221,221,0.4));
  display: flex;
  right: 0;
  left: 0;

  @media screen and (min-width: 600px) {
    position: fixed;
  }

  > div {
    display: flex;
    flex-direction: row;
    flex: 1;
    max-width: 910px;
    justify-content: center;
  }

  @media screen and (max-width: 600px) {
    > div {
      flex-direction: column;
      grid-gap: 10px;
    }
  }
`;
